var _ellipse, _ellipse2, _ellipse3, _circle, _path, _path2, _path3, _g, _path4, _path5, _path6, _g2, _path7, _path8, _path9, _path10, _ellipse4, _ellipse5, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReviewAvatar2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1312_6044)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.2652,
    cy: 22.636,
    rx: 13.1558,
    ry: 16.6994,
    fill: "#3A4855"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.8398,
    cy: 22.636,
    rx: 13.8202,
    ry: 16.6994,
    fill: "#3A4855"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.6443,
    cy: 24.0999,
    rx: 16.6833,
    ry: 15.1433,
    fill: "#3A4855"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.1493,
    cy: 25.9467,
    r: 11.7021,
    fill: "#F89F86"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9512 28.6177H19.6087V30.1061C19.6087 31.3923 18.5661 32.4349 17.2799 32.4349C15.9938 32.4349 14.9512 31.3923 14.9512 30.1061V28.6177Z",
    fill: "url(#paint0_linear_1312_6044)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9512 28.319C14.9512 27.0329 15.9938 25.9902 17.2799 25.9902C18.5661 25.9902 19.6087 27.0329 19.6087 28.319V29.3936C19.6087 30.3876 18.8029 31.1935 17.8089 31.1935H16.751C15.757 31.1935 14.9512 30.3876 14.9512 29.3936V28.319Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1312_6044",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 25,
    width: 6,
    height: 7
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9453 28.3229C14.9453 27.0368 15.9879 25.9941 17.2741 25.9941C18.5602 25.9941 19.6029 27.0368 19.6029 28.3229V29.3975C19.6029 30.3916 18.797 31.1974 17.803 31.1974H16.7452C15.7511 31.1974 14.9453 30.3916 14.9453 29.3975V28.3229Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1312_6044)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.9434,
    y: 26.7559,
    width: 2.79453,
    height: 3.72604,
    rx: 1.39726,
    fill: "#343434"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9668 28.6177H29.6243V30.1061C29.6243 31.3923 28.5817 32.4349 27.2956 32.4349C26.0094 32.4349 24.9668 31.3923 24.9668 30.1061V28.6177Z",
    fill: "url(#paint1_linear_1312_6044)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9668 28.319C24.9668 27.0329 26.0094 25.9902 27.2956 25.9902C28.5817 25.9902 29.6243 27.0329 29.6243 28.319V29.3936C29.6243 30.3876 28.8185 31.1935 27.8245 31.1935H26.7666C25.7726 31.1935 24.9668 30.3876 24.9668 29.3936V28.319Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1312_6044",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 25,
    width: 6,
    height: 7
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9629 28.3229C24.9629 27.0368 26.0055 25.9941 27.2917 25.9941C28.5778 25.9941 29.6204 27.0368 29.6204 28.3229V29.3975C29.6204 30.3916 28.8146 31.1974 27.8206 31.1974H26.7627C25.7687 31.1974 24.9629 30.3916 24.9629 29.3975V28.3229Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1312_6044)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.9609,
    y: 26.7559,
    width: 2.79453,
    height: 3.72604,
    rx: 1.39726,
    fill: "#343434"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4922 24.0571C18.1747 24.5841 16.6879 24.4342 15.3004 24.4342",
    stroke: "#3A4855",
    strokeWidth: 1.52703,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1699 24.0571C26.4874 24.5841 27.9742 24.4342 29.3617 24.4342",
    stroke: "#3A4855",
    strokeWidth: 1.52703,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2289 32.9161C21.4698 33.0247 21.7729 33.1005 22.1495 33.1006C22.5262 33.1006 22.8294 33.0247 23.0703 32.9161",
    stroke: "#F36E49",
    strokeWidth: 0.88,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.375 29.7657L22.3719 27.8445C22.2805 27.6695 22.0301 27.6695 21.9387 27.8445L20.9356 29.7657C20.4574 30.6818 21.1219 31.7785 22.1553 31.7785C23.1887 31.7785 23.8533 30.6818 23.375 29.7657Z",
    fill: "#EA7656"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.87015,
    cy: 28.0789,
    rx: 2.27055,
    ry: 2.58494,
    transform: "rotate(-30 9.87015 28.0789)",
    fill: "#F89F86"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.27055,
    cy: 2.58494,
    rx: 2.27055,
    ry: 2.58494,
    transform: "matrix(-0.866025 -0.5 -0.5 0.866025 38.0801 26.9756)",
    fill: "#F89F86"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0703 12.1372H22.1442V17.6299C22.1442 19.587 20.5577 21.1735 18.6006 21.1735H14.614C12.6569 21.1735 11.0703 19.587 11.0703 17.6299V12.1372Z",
    fill: "#3A4855"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14844 16.8335H13.9069V22.9906C13.9069 24.5807 12.6178 25.8698 11.0276 25.8698C9.43751 25.8698 8.14844 24.5807 8.14844 22.9906V16.8335Z",
    fill: "#3A4855"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56641 21.1748H12.4899V31.5843C12.4899 32.3916 11.8355 33.046 11.0282 33.046C10.2209 33.046 9.56641 32.3916 9.56641 31.5843V21.1748Z",
    fill: "#3A4855"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1582 21.1748H35.0817V31.5843C35.0817 32.3916 34.4273 33.046 33.62 33.046C32.8127 33.046 32.1582 32.3916 32.1582 31.5843V21.1748Z",
    fill: "#3A4855"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7383 16.8335H36.4967V22.9906C36.4967 24.5807 35.2076 25.8698 33.6175 25.8698C32.0273 25.8698 30.7383 24.5807 30.7383 22.9906V16.8335Z",
    fill: "#3A4855"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1465 12.1372H33.2204V17.6299C33.2204 19.587 31.6338 21.1735 29.6767 21.1735H25.6901C23.733 21.1735 22.1465 19.587 22.1465 17.6299V12.1372Z",
    fill: "#3A4855"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1312_6044",
    x1: 17.2799,
    y1: 28.6177,
    x2: 17.2799,
    y2: 32.4349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE7355"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE7355",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1312_6044",
    x1: 27.2956,
    y1: 28.6177,
    x2: 27.2956,
    y2: 32.4349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE7355"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE7355",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1312_6044"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.00195312,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewAvatar2);
export default __webpack_public_path__ + "static/media/review_avatar_2.90684dc5b268c2bcb71bce73fd411376.svg";
export { ForwardRef as ReactComponent };